export * from "jsr:@std/semver@1";
import type { Comparator } from "jsr:@std/semver@1";

// ported from https://jsr.io/@std/semver/1.0.3/_constants.ts
/**
 * A comparator which will span all valid semantic versions
 */
export const ALL: Comparator = {
  operator: undefined,
  major: Number.NaN,
  minor: Number.NaN,
  patch: Number.NaN,
  prerelease: [],
  build: [],
};

// denoCacheMetadata={"headers":{"x-served-by":"cache-iad-kcgs7200100-IAD","via":"1.1 varnish","content-type":"text/plain; charset=utf-8","etag":"W/\"15cad335a3a46788292b9711dc525ff885e1710995e4e1a63a890ec417b00439\"","date":"Fri, 08 Nov 2024 10:10:00 GMT","cache-control":"max-age=300","x-cache-hits":"0","vary":"Authorization,Accept-Encoding,Origin","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","accept-ranges":"bytes","x-xss-protection":"1; mode=block","x-fastly-request-id":"db599e3ad76484fdbbaab6955b944907219e3808","x-content-type-options":"nosniff","access-control-allow-origin":"*","source-age":"90","cross-origin-resource-policy":"cross-origin","x-frame-options":"deny","strict-transport-security":"max-age=31536000","expires":"Fri, 08 Nov 2024 10:15:00 GMT","x-timer":"S1731060601.818188,VS0,VE1","x-cache":"HIT","x-github-request-id":"9B88:179572:12C5AD8:147FFBF:672DDE07"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/deps/semver.ts","time":1731060600}